<template>
  <v-group>
    <template v-for="layer in layers">
      <template v-if="isVisible(layer)">
        <group-layer
          v-if="layer.type === 'Group'"
          :layer="layer"
          :key="layer.id"
          :artworkID="artwork.id"
          :scale="scale"
          :offset="offset"
          :parentRatio="parentRatio"
          :rotation="rotation"
        />
        <image-layer
          v-if="layer.type === 'Image'"
          :layer="layer"
          :key="layer.id"
          :artworkID="artwork.id"
          :scale="scale"
          :offset="offset"
          :parentRatio="parentRatio"
          :rotation="rotation"
        />
        <text-layer
          v-if="layer.type === 'Text'"
          :layer="{ ...layer }"
          :key="layer.id"
          :artworkID="artwork.id"
          :scale="scale"
          :offset="offset"
          :parentRatio="parentRatio"
          :rotation="rotation"
        />
      </template>
    </template>
  </v-group>
</template>

<script>
import { mapGetters } from 'vuex'
import Group from './Group.vue'
import Image from './Image.vue'
import Text from './Text.vue'
import { max, map, get } from 'lodash'
import { checkCondition, isMoonColorVisible } from '@/helper/helper'

export default {
  components: {
    'group-layer': Group,
    'image-layer': Image,
    'text-layer': Text
  },
  name: 'artwork',
  props: {
    artwork: {
      type: Object,
      required: true
    },
    width: {
      type: Number
    },
    offset: {
      type: Object,
      default() {
        return { x: 0, y: 0, offsetX: 0 }
      }
    },
    rotation: {
      type: Number,
      default() {
        return 0
      }
    },
    parentRatio: {
      type: Number,
      default() {
        return 1
      }
    }
  },
  created() {
    localStorage.removeItem('my_font_family_local');
    localStorage.setItem('my_font_family_local', JSON.stringify([]));
  },
  computed: {
    ...mapGetters(['personalized', 'loadings']),
    scale() {
      const { artwork, width, ratio } = this
      if (!width) {
        return 1
      }
      return width / (artwork.width * ratio)
    },
    layers() {
      return this.artwork.templates[0].layers
    },
    ratio() {
      var ratio = 1
      if (this.artwork.width && this.artwork.height) {
        var r = max([this.artwork.width, this.artwork.height])
        var res = 10
        for (; res > 1; res--) {
          if (r * res <= 10000) {
            break
          }
        }
        ratio = res / 10
      }
      return ratio
    },
    stageConfig() {
      const { artwork, scale, ratio } = this
      return {
        width: Math.round(artwork.width * ratio * scale),
        height: Math.round(artwork.height * ratio * scale)
      }
    },
    artworkLoading() {
      const { loadings, artwork } = this
      if (artwork) {
        return map(get(loadings, artwork.id, {})).some(
          loading => loading === true
        )
      }
      return null
    }
  },
  methods: {
    checkCondition(layer) {
      const { personalized, artwork } = this
      const data = get(personalized, artwork.id)
      return checkCondition(layer, data)
    },
    isVisible(layer) {
      if (
        get(layer, 'personalized.enable', false) !== true &&
        layer.excludeMockup === true
      ) {
        return false
      }
      const { personalized, artwork, layers } = this
      const data = get(personalized, artwork.id)
      return this.checkCondition(layer) && isMoonColorVisible(layer, layers, data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Artwork/Artwork.vue